import type { PayloadAction } from '@reduxjs/toolkit';
import type { IcdCodeView } from '../../types/medNecTypes';
import type { MedNecCaseSliceState } from '../state';

const addEditedField = (state: MedNecCaseSliceState, fieldName: string) => {
  if (!state.editedFields.includes(fieldName)) {
    state.editedFields.push(fieldName);
  }
  state.isEdited = true;
};

export const clinicalReducers = {
  updatePhysician: (
    state: MedNecCaseSliceState,
    action: PayloadAction<{ physicianName: string; physicianNpi: string; physicianGroup?: string }>
  ) => {
    if (state.currentCase) {
      state.currentCase.physicianName = action.payload.physicianName;
      state.currentCase.physicianNpi = action.payload.physicianNpi;
      if (action.payload.physicianGroup !== undefined) {
        state.currentCase.physicianGroup = action.payload.physicianGroup;
      }
      addEditedField(state, 'physician');
    }
  },

  updateIcdCodes: (state: MedNecCaseSliceState, action: PayloadAction<IcdCodeView[]>) => {
    if (state.currentCase) {
      state.currentCase.icdCodes = action.payload;
      addEditedField(state, 'icdCodes');
    }
  },

  updateCptCodes: (state: MedNecCaseSliceState, action: PayloadAction<string[]>) => {
    if (state.currentCase) {
      state.currentCase.cptCodes = action.payload;
      addEditedField(state, 'cptCodes');
    }
  },

  updateLevelOfCare: (state: MedNecCaseSliceState, action: PayloadAction<string>) => {
    if (state.currentCase) {
      state.currentCase.levelOfCare = action.payload;
      addEditedField(state, 'levelOfCare');
    }
  },

  updateNotes: (state: MedNecCaseSliceState, action: PayloadAction<string>) => {
    if (state.currentCase) {
      state.currentCase.notes = action.payload;
      addEditedField(state, 'notes');
    }
  },

  updatePayerInfo: (
    state: MedNecCaseSliceState,
    action: PayloadAction<{ payerId: string; payerName: string }>
  ) => {
    if (state.currentCase) {
      state.currentCase.payerId = action.payload.payerId;
      state.currentCase.payerName = action.payload.payerName;
      addEditedField(state, 'payer');
    }
  },
};
